<ion-button *ngIf="!expanded" class="button-color-primary" (click)="setExpanded(true)"
  [ngClass]="{'action-button-expand-wide': !large, 'action-button-fill': large}">
  <icon-wrapper slot="icon-only" icon="caret-down" iconIos="chevron-down-circle-outline"></icon-wrapper>
</ion-button>
<ion-button *ngIf="expanded" class="button-color-primary" (click)="setExpanded(false)"
  [ngClass]="{'action-button-expand-wide': !large, 'action-button-fill': large}">
  <icon-wrapper slot="icon-only" icon="caret-up" iconIos="chevron-up-circle-outline"></icon-wrapper>
</ion-button>